/**
 * Created by luan.vu on 1/25/17.
 */

/**
 * OS types
 */
const IOS_TYPE = "iOS";
const ANDROID_TYPE = "Android";
const WINDOWS_PHONE_TYPE = "Windows Phone";
const UNKNOWN_TYPE = "unknown";
const TICKET_SALE_LIMIT_ERROR = "Oh no. We are not able to fulfil that many tickets for ";